import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  useEffect,
} from 'react';

import {
  Analytics,
  createBrowserAnalytics,
  createNoopAnalytics,
} from '../services/analytics';

const AnalyticsContext = createContext<Analytics>(createNoopAnalytics());

export const AnalyticsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [analytics, setAnalytics] = useState<Analytics>(() =>
    createNoopAnalytics()
  );

  useEffect(() => {
    let cancelled = false;
    if (typeof window === 'undefined') return;
    (async () => {
      const instance = await createBrowserAnalytics();
      if (!cancelled) setAnalytics(instance);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(() => analytics, [analytics]);
  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export function useAnalytics(): Analytics {
  return useContext(AnalyticsContext);
}
